<template>
<div id="unit_main">
  <dd-pager
    :pageNo="pageNo"
    :dataCountPerPage="dataCount"
    :totalDataCount="totalCount"
    @callback="paging"
  />
  <section>
    <div class="mainlist" v-if="unitList && unitList.length > 0">
      <article
        class="unitlist"
        v-for="(fileData, index) in unitList"
        :key="index"
        @click="onClick(isOpen ? fileData.fdId : fileData.spaceJoincd); $emit('selectedUnit', index)"
        v-bind:class="{select_item: selectUnitNo == index}"
      >
        <img :src="getFileUrl(fileData.iconName)" width="200" height="150" alt="unitlist" draggable="false"/>
        <dl>
          <dt>{{ isOpen ? fileData.openFdName : fileData.fileName }}</dt>
          <dd class="company">{{ fileData.corpNameShort }}</dd>
          <dd class="category">
            <span class="category">{{ isOpen ? fileData.objGroupName : getObjGrp(fileData) }}</span>
            <span class="category">Ver.{{ fileData.fileVersion }}</span>
          </dd>
        </dl>
      </article>
    </div>
  </section>
</div>
</template>
<script>
import * as App from '../../utils/App'
import {OBJECT_GROUP_TYPE} from '../../constants/Type'
import Pager from '../../components/common/Pager'
export default {
  name: 'dd-file-List',
  components: {
    'dd-pager': Pager
  },
  props: {
    unitList: Array,
    pageNo: Number,
    dataCount: Number,
    totalCount: Number,
    isOpen: Boolean,
    selectUnitNo: Number
  },
  methods: {
    /** 詳細モーダル表示 */
    onClick: function (param) {
      this.$emit('getDetailData', param)
    },
    /** 画像取得 */
    getFileUrl: function (iconName) {
      let fileName = iconName ? iconName.replace(/'/g, "¥'") : 'noimage'
      return this.getImage(fileName + '.svg')
    },
    paging: function (currentPageNo) {
      if (this.isOpen) {
        this.$emit('getOpenUnitList', currentPageNo, this.dataCount)
      } else {
        this.$emit('getUnitList', currentPageNo, this.dataCount)
      }
    },
    /** オブジェクトグループ名取得 */
    getObjGrp: function (fileData) {
      // 企業ユニットの場合のみ
      if (!this.isOpen && fileData.objectDataModelList[0].objDtlTypeMaster !== null) {
        let grpType = fileData.objectDataModelList[0].objDtlTypeMaster.objGroupType
        if (grpType) {
          let NameType = Object.keys(OBJECT_GROUP_TYPE).map(key => {
            return OBJECT_GROUP_TYPE[key]
          }).find(objGrpType => objGrpType.code === grpType)
          return NameType.label
        } else {
          return 'カテゴリ'
        }
      } else {
        return 'カテゴリ'
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>
<style src="../../css/unit/unit.scss"  lang="scss" scoped></style>
<style scoped>
.unitlist:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/unit/UnitList.vue